import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';

import {
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Modal,
    Box,
    Button,
    Card,
    Alert,
    CardContent,
    CardHeader,
    Divider,
    TextField,
    MenuItem,
    InputLabel,
    Select,
    FormHelperText,
    Grid,
    Stack,
    Container
} from "@mui/material";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import LayersIcon from "@mui/icons-material/Layers";
import Snackbar from "@mui/material/Snackbar";
import LinearProgress from "@mui/material/LinearProgress";
import Notification from "../../pages/General/Notification";
import { fetchBoxData } from '../../pages/Settings/Box/boxSlice';
import { fetchProfile } from '../Settings/Profile/profileSlice';
import {
  fetchPickOrderDetail,
  fetchPickOrderDetailitems,
  putOrderItemsDetails,
  resetOrderPickNotification
} from "../../pages/OrderPicklist/orderpicklistSlice";
import {
    resetOrderNotifications,
    updateBulkDimension
} from '../../pages/Orders/ordersSlice';

// Global enterprise styling dictionary configuring standard outlined layouts
const enterpriseDimInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2', // --- CORPORATE IDENTITY BRAND BLUE ---
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        },
        '&.Mui-disabled': {
            backgroundColor: '#F8FAFC',
            borderColor: '#F1F5F9',
            color: '#94A3B8'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        },
        '&.Mui-disabled': {
            color: '#CBD5E1'
        }
    },
    '& input, & .MuiSelect-select': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const DimUpdatePage = () => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.profile.profile);
    const box = useSelector(state => state.box)
    const orders = useSelector(state => state.orders);
    const orderpicklistitems = useSelector((state) => state.orderpicklist);
    const [boxData, setBoxData] = useState([])
    const [meta, setMeta] = useState(orders.ordersData.meta);
    const [alert, setAlert] = useState(false);
    const [open, setOpen] = useState(false);
    const [orderId, setOrderId] = useState("");
    const [orderSubmit, setorderSubmit] = useState(false);
    const [boxNameScan, setBoxNameScan] = useState("");
    const [boxNameFocus, setBoxNameFocus] = useState(false);
    const initialBoxValues = {
        "_id":0,
        "box_name": 'custom',
        "box_length": "",
        "box_width": "",
        "box_height": "",
        "box_dimension_unit": "",
        "box_actual_weight": "",
        "box_weight_unit": "",
    }
    const [dimensionValue, setDimensionValue] = useState(initialBoxValues);
    const [dimensionsErrors, setDimensionsErrors] = useState({});
    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.box_name,
        });

    const getChooseMeasurement = (currentvalue) => {
    let filteredCurrentValue = {};
    let tempValue = "";
    boxData &&
    boxData.map((key) => {
        if (key._id == currentvalue && tempValue == "") {
            filteredCurrentValue = key;
            tempValue = "success";
        }
        });
    return filteredCurrentValue;
    };

    const onBoxDimensionChange=(event)=>{
        let packageFieldData = {...dimensionValue};
        if(event.target.name==='choosenmeasurement'){
            if (event.target.value != 0) {
                box && box.data && box.data.map((boxData) => {
                    if (boxData._id === event.target.value) {
                        setDimensionValue({
                            ...dimensionValue,
                            "_id": event.target.value,
                            "box_name": boxData.box_name,
                            "box_length": parseFloat(boxData.box_length).toFixed(2),
                            "box_width": parseFloat(boxData.box_width).toFixed(2),
                            "box_height": parseFloat(boxData.box_height).toFixed(2),
                            "box_dimension_unit": boxData.length_unit,
                            "box_actual_weight": parseFloat(boxData.box_weight).toFixed(2),
                            "box_weight_unit": boxData.box_weight_unit
                        });
                        setDimensionsErrors({})
                    }
                })
            }else{
                setDimensionValue({
                    ...dimensionValue,
                    "_id":0,
                    "box_name": 'custom',
                    "box_length": "",
                    "box_width": "",
                    "box_height": "",
                    "box_dimension_unit": "",
                    "box_actual_weight": "",
                    "box_weight_unit": ""
                });
                setDimensionsErrors({})
            }
        }else{
            packageFieldData[event.target.name] = event.target.value;
            setDimensionValue(packageFieldData);
            validator({ [event.target.name]: event.target.value })
        }
    }
    const validator = (fieldValues) => {
        let temp = { ...dimensionsErrors }
        if ('box_length' in fieldValues)
            temp.box_length = fieldValues.box_length ? "" : "This field is required."
        if (fieldValues && fieldValues.box_length && fieldValues.box_length <= 0)
            temp.box_length = "Length is not a negative number or 0"
        if ('box_dimension_unit' in fieldValues)
            temp.box_dimension_unit = fieldValues.box_dimension_unit ? "" : "This field is required."
        if ('box_width' in fieldValues)
            temp.box_width = fieldValues.box_width ? "" : "This field is required."
        if (fieldValues && fieldValues.box_width && fieldValues.box_width <= 0)
            temp.box_width = "Width is not a negative number  or 0"
        if ('box_height' in fieldValues)
            temp.box_height = fieldValues.box_height ? "" : "This field is required."
        if (fieldValues && fieldValues.box_height && fieldValues.box_height <= 0)
            temp.box_height = "Height is not a negative number  or 0"
        if(typeof (profile && profile.use_auto_weight)==='undefined'){
            if ('box_actual_weight' in fieldValues)
                temp.box_actual_weight = fieldValues.box_actual_weight ? "" : "This field is required."
            if (fieldValues && fieldValues.box_actual_weight && fieldValues.box_actual_weight <= 0)
                temp.box_actual_weight = "Weight is not a negative number  or 0"
            if ('box_weight_unit' in fieldValues)
                temp.box_weight_unit = fieldValues.box_weight_unit ? "" : "This field is required."
        }
        setDimensionsErrors({
            ...temp
        })

        if (fieldValues === dimensionValue)
            return Object.values(temp).every(x => x == "")
    }

    const onInputClear = () => {
        setOrderId("");
        setorderSubmit(false)
        setDimensionValue(initialBoxValues)
        setBoxNameScan("")
        setDimensionsErrors({})
    };

    const onBoxNameScanClear =() =>{
        setBoxNameScan("")
        setDimensionsErrors({})
        setDimensionValue(initialBoxValues)
    }
    const handleSubmit = () => {
        setorderSubmit(true)
        dispatch(fetchPickOrderDetail(orderId));
    };

    const handleSnackClose = () => {
        setOpen(false);
        dispatch(resetOrderPickNotification())
      };

    const handleBoxScanSearch = () => {
        const value = boxNameScan;
        const foundBox = boxData.find((box) => box.box_name.toLowerCase() === value.toLowerCase());
        if(typeof foundBox!=='undefined'){
            setDimensionValue({
                ...dimensionValue,
                "_id":foundBox._id,
            })
            let event = {
                "target": {
                    "name": "choosenmeasurement",
                    "value":foundBox._id
                }
            }
            onBoxDimensionChange(event);
        }else{
            setDimensionValue(initialBoxValues)
        }
        setorderSubmit(true)
      };

    const addBulkDimensionsForm =()=>{
        const isValid = validator(dimensionValue)
        if (isValid) {
            let docIdArray=[]
            docIdArray.push(orderpicklistitems && orderpicklistitems.orderpickdetail &&
                orderpicklistitems.orderpickdetail.data &&
                orderpicklistitems.orderpickdetail.data._id)
            let docid={'docids':docIdArray}
            Object.assign(dimensionValue, docid);
            setDimensionsErrors({})
            console.log(dimensionValue)
            if(orderId!==""){
                dispatch(updateBulkDimension(profile && profile.id,dimensionValue,meta))
            }
        }
    }

     useEffect(() => {
            if (orderpicklistitems && orderpicklistitems.orderpickdetail &&
                orderpicklistitems.orderpickdetail.data && orderpicklistitems.orderpickdetail.data.length!==0 && orderpicklistitems.orderpickdetail.data.product_info && orderId!=='') {
                const dimensionsArray = [orderpicklistitems.orderpickdetail.data.product_info];
                dimensionsArray.map((item) => {
                    setDimensionValue({
                        ...dimensionValue,
                        "_id": 0,
                        "box_name": "",
                        "box_length": item && item.dimensions && item.dimensions.length && item.dimensions.length >0 ? parseFloat(item.dimensions.length).toFixed(2) : 0,
                        "box_width": item &&  item.dimensions.width && item.dimensions.width>0 ? parseFloat(item.dimensions.width).toFixed(2) : 0,
                        "box_height": item && item.dimensions && item.dimensions.height && item.dimensions.height >0 ? parseFloat(item.dimensions.height).toFixed(2) : 0,
                        "box_dimension_unit": item && item.dimensions && item.dimensions.height_unit!=='' ? item.dimensions.height_unit :"",
                        "box_actual_weight": item && item.actual_weight >0 ?parseFloat(item.actual_weight).toFixed(2) : 0,
                        "box_weight_unit": item && item.weight_unit!=='' ? item.weight_unit :"",
                    });
                })
            }
    }, [orderpicklistitems])

    useEffect(() => {
            dispatch(fetchBoxData(false));
            dispatch(fetchProfile())
        }, [dispatch]);

    useEffect(() => {
        if(dimensionValue && dimensionValue.length!=='' && orderId!=='' && boxNameScan!==''){
            addBulkDimensionsForm()
            setDimensionsErrors({})
        }
    }, [dimensionValue]);

     useEffect(() => {
            let tempBoxData=[]
            let customValue={"_id":0,"box_name":"custom"}
            tempBoxData.push(customValue)
            let boxOriginalData = box && box.data.filter(function( obj ) {
                return  obj.hide !== true;
                });
            if (boxOriginalData.length !== 0) {
                boxOriginalData.map((item) => {
                    tempBoxData.push(item)
                })
                setBoxData(tempBoxData)
            }else{
                setBoxData(tempBoxData)
            }
        }, [box && box.data]);

    useEffect(() => {
        if(orderpicklistitems && orderpicklistitems.orderpickdetail && orderpicklistitems.orderpickdetail.notification && orderpicklistitems.orderpickdetail.notification.messageType=='error'){
            setAlert(true)
            setOpen(true)
        }else{
          setAlert(false)
          setOpen(false)
        }
    
      },[orderpicklistitems.orderpickdetail])

      useEffect(() => {
        if(orders && orders.addBulkDimension.notification && orders.addBulkDimension.notification.messageContent  && orders.addBulkDimension.notification.messageContent[0]  && orders.addBulkDimension.notification.messageContent[0]==='dimensions updated successfully'){
            setOrderId("")
            setorderSubmit(false)
            setDimensionValue(initialBoxValues)
            setBoxNameScan("")
        }
      },[orders && orders.addBulkDimension])

    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
        {alert && (
                <Snackbar
                  open={open}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  autoHideDuration={6000}
                  onClose={handleSnackClose}
                  sx={{ mt: 2 }}
                >
                  <Alert
                    severity={"error"}
                    variant="filled"
                    sx={{ width: '100%', borderRadius: '12px', fontWeight: 600, fontSize: '13px', alignItems: 'center' }}
                    onClose={handleSnackClose}
                  >
                    <span> {orderpicklistitems.orderpickdetail.notification.messageContent.message}</span>
                  </Alert>
                </Snackbar>
              )}
        {(orders && orders.addBulkDimension.notification && orders.addBulkDimension.notification.show) &&
                        <Notification
                            is_open={orders.addBulkDimension.notification.show}
                            messageType={orders.addBulkDimension.notification.messageType}
                            messages={orders.addBulkDimension.notification.messageContent}
                            handleClose={() => dispatch(resetOrderNotifications())}
        />}
            
            {/* Page Header Layout Bar */}
            <Box sx={{ p: 1, mb: 1 }}>
                <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px' }}>
                    Dim Update
                </Typography>
            </Box>

            <Stack spacing={3}>
                
                {/* Panel Section 1: Order Scan & Identification Input Terminal */}
                <Card 
                    sx={{ 
                        width: '100%', 
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E2E8F0',
                        borderRadius: '16px',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
                    }}
                >
                    <CardContent sx={{ p: 4 }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="center">
                            <Box sx={{ width: { xs: '100%', sm: '320px' } }}>
                                <TextField
                                    value={orderId}
                                    name={"orderid"}
                                    label="Order ID*"
                                    size="small"
                                    onInput={(e) => {
                                        setOrderId(e.target.value)
                                        setorderSubmit(false)
                                        setBoxNameFocus(true)
                                    }}
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: orderId ? (
                                            <IconButton size="small" onClick={() => onInputClear()} sx={{ color: '#94A3B8' }}>
                                                <ClearIcon sx={{ fontSize: '16px' }} />
                                            </IconButton>
                                        ) : undefined,
                                    }}
                                    onKeyUp={(event) => {
                                        if (event.key === "Enter") handleSubmit();
                                    }}
                                    inputRef={(orderinput) => {
                                        if (orderId === '' && orderSubmit === false)
                                            orderinput && orderinput.focus()
                                    }}
                                    sx={enterpriseDimInputStyles}
                                />
                            </Box>
                            <Button
                                variant="contained"
                                onClick={handleSubmit}
                                startIcon={<SearchIcon sx={{ fontSize: '16px !important' }} />}
                                disabled={orderId === ""}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 4,
                                    boxShadow: 'none',
                                    backgroundColor: '#1976d2',
                                    color: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                    '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' },
                                    width: { xs: '100%', sm: 'auto' }
                                }}
                            >
                                Search
                            </Button>
                        </Stack>

                        {/* Real-time scanning entity metadata indicators */}
                        {orderSubmit && orderId !== '' && orderpicklistitems && orderpicklistitems.orderpickdetail &&
                        orderpicklistitems.orderpickdetail.data && orderpicklistitems.orderpickdetail.data.length !== 0 && orderpicklistitems.orderpickdetail.data.order && orderpicklistitems.orderpickdetail.data.order.id && orderId === orderpicklistitems.orderpickdetail.data.order.id && (
                            <Box sx={{ mt: 3, p: 2, backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0', maxWidth: '450px', mx: 'auto' }}>
                                <Stack spacing={1}>
                                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 500, fontSize: '13px' }}>
                                        Order ID: <Box component="span" sx={{ color: '#0F172A', fontWeight: 700 }}>{orderpicklistitems?.orderpickdetail?.data?.order?.id}</Box>
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 500, fontSize: '13px' }}>
                                        Order Status: <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}>{orderpicklistitems?.orderpickdetail?.data?.order?.status}</Box>
                                    </Typography>
                                </Stack>
                            </Box>
                        )}
                    </CardContent>
                </Card>

                {/* Async Operations Loading Framework Ticker Indicator */}
                {orderpicklistitems && orderpicklistitems.orderpickdetail && orderpicklistitems.orderpickdetail.loading && (
                    <LinearProgress sx={{ height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                )}

                {/* Panel Section 2: Dimension Metrics Optimization Entry Canvas */}
                <Card 
                    sx={{ 
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        border: '1px solid #E2E8F0',
                        borderRadius: '16px',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                        overflow: 'hidden'
                    }} 
                    className="sc--cardhead--details"
                >
                    <CardHeader
                        title={
                            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                                Dimension Details
                            </Typography>
                        }
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    {orders && orders.addBulkDimension && orders.addBulkDimension.loading && (
                        <LinearProgress sx={{ height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                    )}
                    <Divider sx={{ borderColor: '#E2E8F0' }} />

                    <CardContent sx={{ p: 4, boxSizing: 'border-box' }}>
                        <Container maxWidth="sm" disableGutters>
                            <Stack spacing={3}>
                                
                                {/* 1. Quick Box Hardware barcode scanner field input track */}
                                {orderId !== '' && Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail && orderpicklistitems.orderpickdetail.data).length !== 0 && (
                                    <Box sx={{ width: '100%', minHeight: '40px' }}>
                                        <TextField 
                                            id="insurance-amount-id"
                                            label="Box Name Scan"
                                            variant="outlined"
                                            size="small"
                                            name="box_name_search"
                                            inputProps={{ min: 1 }}
                                            value={boxNameScan}
                                            onInput={(e) => {
                                                setBoxNameScan(e.target.value)
                                            }}
                                            InputProps={{
                                                endAdornment: orderId ? (
                                                    <IconButton size="small" onClick={() => onBoxNameScanClear()} sx={{ color: '#94A3B8' }}>
                                                        <ClearIcon sx={{ fontSize: '16px' }} />
                                                    </IconButton>
                                                ) : undefined,
                                            }}
                                            onKeyUp={(event) => {
                                                if (event.key === "Enter") {
                                                    handleBoxScanSearch();
                                                }
                                            }}
                                            onBlur={(e) => {
                                                e.target.blur();
                                                setBoxNameFocus(false)
                                            }}
                                            inputRef={(boxnamescaninput) => {
                                                if(orderId !== '' && orderSubmit && boxNameFocus)
                                                    boxnamescaninput && boxnamescaninput.focus()
                                            }}
                                            sx={enterpriseDimInputStyles}
                                        />
                                    </Box>
                                )}

                                {/* 2. Standard Predefined Package Autocomplete Selection Dropdown */}
                                <Box sx={{ width: '100%', minHeight: '40px' }}>
                                    <Autocomplete
                                        className="help-text-error"
                                        disablePortal
                                        size="small"
                                        name="choosenmeasurement"
                                        id="state-select-demo"
                                        options={boxData}
                                        autoHighlight
                                        loading={(box && box.loading)}
                                        getOptionLabel={(option) => option.box_name === 'custom' ? "" + option.box_name + "" : ("" + option.box_name + " (" + option.box_length + option.box_length_unit + "x " + option.box_width + option.box_width_unit + "x " + option.box_height + option.box_height_unit + ", " + option.box_weight + option.box_weight_unit + ")")}
                                        filterOptions={filterOptions}
                                        value={getChooseMeasurement(dimensionValue._id)}
                                        sx={{
                                            width: '100%',
                                            '& .MuiAutocomplete-inputRoot': enterpriseDimInputStyles['& .MuiOutlinedInput-root'],
                                            '& .MuiInputLabel-root': enterpriseDimInputStyles['& .MuiInputLabel-outlined'],
                                            '& input': enterpriseDimInputStyles['& input']
                                        }}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} value={option._id} key={option._id} sx={{ fontSize: '13.5px', color: '#1E293B', fontWeight: 500 }}>
                                                {option.box_name === 'custom' ? (
                                                    <Box component="p" sx={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                                                        {option.box_name}
                                                    </Box>
                                                ) : (
                                                    <Box component="p" sx={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                                                        {option.box_name} (
                                                        {option.box_length}{option.box_length_unit} <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}> x </Box>
                                                        {option.box_width}{option.box_width_unit} <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}> x </Box>
                                                        {option.box_height}{option.box_height_unit}<span>, </span>
                                                        {option.box_weight}{option.box_weight_unit})
                                                    </Box>
                                                )}
                                            </MenuItem>
                                        )}
                                        onChange={(event, value) => {
                                            if (value !== null) {
                                                let event = {
                                                    "target": {
                                                        "name": "choosenmeasurement",
                                                        "value": value._id
                                                    }
                                                }
                                                onBoxDimensionChange(event);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Choose Measurement"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Box>

                                {/* 3. Volume Vectors Fields Matrix Block Layout */}
                                <Grid container spacing={0.5}>
                                    <Grid item xs={6} sm={3}>
                                        <Box sx={{ minHeight: '40px' }}>
                                            <TextField 
                                                label="Length"
                                                variant="outlined"
                                                size="small"
                                                name="box_length"
                                                type="number"
                                                inputProps={{ min: 1 }}
                                                value={dimensionValue.box_length}
                                                onChange={event => onBoxDimensionChange(event)}
                                                error={!!dimensionsErrors.box_length}
                                                helperText={dimensionsErrors.box_length}
                                                sx={enterpriseDimInputStyles}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Box sx={{ minHeight: '40px' }}>
                                            <TextField 
                                                label="Width"
                                                variant="outlined"
                                                size="small"
                                                name="box_width"
                                                type="number"
                                                inputProps={{ min: 1 }}
                                                value={dimensionValue.box_width}
                                                onChange={event => onBoxDimensionChange(event)}
                                                error={!!dimensionsErrors.box_width}
                                                helperText={dimensionsErrors.box_width}
                                                sx={enterpriseDimInputStyles}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Box sx={{ minHeight: '40px' }}>
                                            <TextField 
                                                label="Height"
                                                variant="outlined"
                                                size="small"
                                                name="box_height"
                                                type="number"
                                                inputProps={{ min: 1 }}
                                                value={dimensionValue.box_height}
                                                onChange={event => onBoxDimensionChange(event)}
                                                error={!!dimensionsErrors.box_height}
                                                helperText={dimensionsErrors.box_height}
                                                sx={enterpriseDimInputStyles}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Box sx={{ minHeight: '40px' }}>
                                            <FormControl variant="outlined" size="small" sx={enterpriseDimInputStyles} error={!!dimensionsErrors.box_dimension_unit}>
                                                <InputLabel id="dim-unit-outlined-label">Dim Unit</InputLabel>
                                                <Select
                                                    labelId="dim-unit-outlined-label"
                                                    name="box_dimension_unit"
                                                    onChange={event => onBoxDimensionChange(event)}
                                                    value={dimensionValue.box_dimension_unit}
                                                    label="Dim Unit"
                                                    id="filled-error-helper-text"
                                                >
                                                    <MenuItem value="in">in</MenuItem>
                                                    <MenuItem value="cm">cm</MenuItem>
                                                </Select>
                                                {dimensionsErrors.box_dimension_unit && <FormHelperText>{dimensionsErrors.box_dimension_unit}</FormHelperText>}
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/* 4. Actual Hardware Weight Values & Scaling Dropdown Configuration */}
                                <Grid container spacing={0.5}>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ minHeight: '40px' }}>
                                            <TextField 
                                                label="Actual Weight"
                                                variant="outlined"
                                                size="small"
                                                name="box_actual_weight"
                                                type="number"
                                                inputProps={{ min: 1 }}
                                                value={dimensionValue.box_actual_weight}
                                                autoFocus={true}
                                                onChange={event => onBoxDimensionChange(event)}
                                                error={!!dimensionsErrors.box_actual_weight}
                                                helperText={dimensionsErrors.box_actual_weight}
                                                sx={enterpriseDimInputStyles}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box sx={{ minHeight: '40px' }}>
                                            <FormControl variant="outlined" size="small" sx={enterpriseDimInputStyles} error={!!dimensionsErrors.box_weight_unit}>
                                                <InputLabel id="weight-unit-outlined-label">Weight Unit</InputLabel>
                                                <Select
                                                    labelId="weight-unit-outlined-label"
                                                    name="box_weight_unit"
                                                    onChange={event => onBoxDimensionChange(event)}
                                                    value={dimensionValue.box_weight_unit}
                                                    label="Weight Unit"
                                                >
                                                    <MenuItem value="lb">lb</MenuItem>
                                                    <MenuItem value="kg">kg</MenuItem>
                                                    <MenuItem value="g">g</MenuItem>
                                                </Select>
                                                {dimensionsErrors.box_weight_unit && <FormHelperText>{dimensionsErrors.box_weight_unit}</FormHelperText>}
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/* Submission Operations Control Bar Trigger Section Footer */}
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pt: 2, borderTop: '1px solid #E2E8F0', mt: 1 }}>
                                    <Button
                                        variant="contained"
                                        onClick={addBulkDimensionsForm}
                                        disabled={orderId === "" || (orders && orders.addBulkDimension && orders.addBulkDimension.loading) || Object.keys(orderpicklistitems && orderpicklistitems.orderpickdetail && orderpicklistitems.orderpickdetail.data).length === 0}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13.5px',
                                            height: '38px',
                                            px: 4,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                            '&.Mui-disabled': {
                                                backgroundColor: '#E2E8F0',
                                                color: '#94A3B8'
                                            }
                                        }}                                
                                    >
                                        Update
                                    </Button>
                                </Box>

                            </Stack>
                        </Container>
                    </CardContent>
                </Card>

            </Stack>
        </Box>
    );
};

export default DimUpdatePage;